import type { ColumnId } from "../../config/types";
import { ProductCell } from "./ProductCell";
import { ImageCell } from "./ImageCell";
import { QuantityCell } from "./QuantityCell";
import { UnitCell } from "./UnitCell";
import { WeightCell } from "./WeightCell";
import { PriceCell } from "./PriceCell";
import { CommentCell } from "./CommentCell";
import { StatusCell } from "./StatusCell";
import { PartnerCell } from "./PartnerCell";
import { OrderNumberCell } from "./OrderNumberCell";
import { ActionsCell } from "./ActionsCell";
import { TotalCell } from "./TotalCell";
import { CustomFieldsCell } from "./CustomFieldsCell";
import { SelectCell } from "./SelectCell";

export const CELL_REGISTRY: Partial<
  Record<ColumnId, React.ComponentType<any>>
> = {
  select: SelectCell,
  product: ProductCell,
  image: ImageCell,
  quantity: QuantityCell,
  unit: UnitCell,
  weight: WeightCell,
  price: PriceCell,
  total: TotalCell,
  comment: CommentCell,
  status: StatusCell,
  partner: PartnerCell,
  order_number: OrderNumberCell,
  actions: ActionsCell,
  custom_fields: CustomFieldsCell,
};
